<template>
  <div class="compressed-content">
    <h3 class="page-question">Have your parents, siblings or children had any of the following? <br /> <i>(check all that apply)</i></h3>
    <h3 class="page-question">Any of your children with LDL cholesterol > 160 mg/dL before age 18</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadEarlyHighLDLC">
      <b-row class="mb-0 mb-lg-4">
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadEarlyHighLDLC"
                        name="early-high-ldlc" :value="diagnosisStatus.Yes">
            Yes
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadEarlyHighLDLC"
                        name="early-high-ldlc" :value="diagnosisStatus.No">
            No
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadEarlyHighLDLC"
                        name="early-high-ldlc" :value="diagnosisStatus.Unknown">
            Unknown
          </b-form-radio>
        </b-col>
      </b-row>
    </v-form-group>
    <h3 class="page-question">Adults with LDL-C > 190 mg/dL</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadHighLDLC">
      <b-row class="mb-0 mb-lg-4">
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadHighLDLC"
                        name="high-ldlc" :value="diagnosisStatus.Yes">
            Yes
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadHighLDLC"
                        name="high-ldlc" :value="diagnosisStatus.No">
            No
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadHighLDLC"
                        name="high-ldlc" :value="diagnosisStatus.Unknown">
            Unknown
          </b-form-radio>
        </b-col>
      </b-row>
    </v-form-group>
    <h3 class="page-question">Thick Achilles tendons</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadThickAchilles">
      <b-row class="mb-0 mb-lg-4">
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadThickAchilles"
                        name="thick-achilles" :value="diagnosisStatus.Yes">
            Yes
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadThickAchilles"
                        name="thick-achilles" :value="diagnosisStatus.No">
            No
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadThickAchilles"
                        name="thick-achilles" :value="diagnosisStatus.Unknown">
            Unknown
          </b-form-radio>
        </b-col>
      </b-row>
    </v-form-group>
    <h3 class="page-question">Cholesterol deposits in their skin or tendons (xanthomas)</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadXanthomas">
      <b-row class="mb-0 mb-lg-4">
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadXanthomas"
                        name="xanthomas" :value="diagnosisStatus.Yes">
            Yes
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadXanthomas"
                        name="xanthomas" :value="diagnosisStatus.No">
            No
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadXanthomas"
                        name="xanthomas" :value="diagnosisStatus.Unknown">
            Unknown
          </b-form-radio>
        </b-col>
      </b-row>
    </v-form-group>
    <h3 class="page-question">White ring around the colored part of the eye (corneal arcus) before the age of 45</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadCornealArcus">
      <b-row class="mb-0 mb-lg-4">
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadCornealArcus"
                        name="corneal-arcus" :value="diagnosisStatus.Yes">
            Yes
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadCornealArcus"
                        name="corneal-arcus" :value="diagnosisStatus.No">
            No
          </b-form-radio>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-radio class="m-lg-0 w-lg-100" v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadCornealArcus"
                        name="corneal-arcus" :value="diagnosisStatus.Unknown">
            Unknown
          </b-form-radio>
        </b-col>
      </b-row>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import diagnosisStatus from "enums/diagnosis-status";
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    data() {
      return {
        diagnosisStatus: diagnosisStatus,
      }
    },

    validations: {
      hadEarlyHighLDLC: {
        required
      },
      hadHighLDLC: {
        required
      },
      hadThickAchilles: {
        required
      },
      hadXanthomas: {
        required
      },
      hadCornealArcus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadEarlyHighLDLC() { return this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadEarlyHighLDLC; },
      hadHighLDLC() { return this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadHighLDLC; },
      hadThickAchilles() { return this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadThickAchilles; },
      hadXanthomas() { return this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadXanthomas; },
      hadCornealArcus() { return this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.hadCornealArcus; }
    }
  };
</script>